import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useField } from 'formik';

const FormikBoolean = ({
  disabled,
  name,
  value = false,
  onBlur,
  onChange,
}) => {
  const [field, , helpers] = useField(name);
  const checked = useMemo(() => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return Boolean(value);
    if (typeof value === 'string') return Boolean(Number(value));
    return null;
  }, [value]);

  const handleChange = event => {
    const bitVal = String(Number(event?.target?.checked ?? false));
    if (field?.value === bitVal) return;
    if (onChange) {
      onChange(bitVal);
    } else {
      helpers.setValue(bitVal);
    }
  };

  return (
    <Form.Check
      className="formik-inline-check"
      inline
      checked={checked}
      disabled={disabled}
      name={name}
      onBlur={onBlur}
      onChange={handleChange}
    />
  );
};

FormikBoolean.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

export default FormikBoolean;
